<admin-controller [parentForm]="instructionForm" label="Instruction"/>
